const signedIn = (state = false, action) => {
  switch (action.type) {
    case 'SET_SIGNED_IN':
      return action.signedIn
    default:
      return state
  }
}

export default signedIn;